import { ManageTable, type ManageField } from '@/components/ManageTable'
import { Textarea } from '@/components/ui/textarea'

export default function Node() {
  const fields: ManageField[] = [
    {
      desc: '名称',
      field: 'serve_name',
    },
    {
      desc: 'ip',
      field: 'serve_ip',
    },
    {
      desc: '链接方式',
      field: 'serve_type',
    },
    {
      desc: '钥匙',
      field: 'serve_key',
      NoShowInTable: true,
      Comp: <Textarea />,
    },
    {
      desc: '更新时间',
      field: 'update_time',
    },
  ]

  return (
    <div className="h-full p-6 overflow-auto">
      <h1 className="text-2xl font-bold mb-6">节点管理</h1>
      <ManageTable fields={fields} collect="node" modalWidth="80%" />
    </div>
  )
}
